import axios from 'axios'
// import {
//   MessageBox,
//   Message
// } from 'element-ui'
// import store from '@/store'
import { getToken, isEmulation } from '@/utils/auth'
import router from '@/router'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 300000 // request timeout //issue 331
  // headers: {
  //   'Content-Type': 'application/x-www-form-urlencoded'
  // }
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (config.data) {
      // This is to prevent axios remove undefined fields
      Object.keys(config.data).forEach(function (key) {
        if (config.data[key] === undefined) config.data[key] = null
      })
    }
    const token = getToken()
    if (token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers['Authorization'] = 'Bearer ' + token
      if(isEmulation()) {
        config.headers['isEmulation'] = isEmulation()
      }      
      // config.headers['x-query-debug'] = true
    }
    return config
  },
  error => {
    // do something with request error
    console.error('DEBUG: ' + error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {

    const res = response.data

    if (response.status !== 200) {
      return Promise.reject(res.message || 'error')
    }
    return res
  },
  error => {
    if (error.response && error.response.status === 401) { // Unauthorized
      const whiteList = ['/login', '/create-pass', '/forgot-pass', '/confirm-forgot-pass', /^\/siteresponse\/.*/]
      store.dispatch('user/resetToken')
      if (!whiteList.find(path => {
        if (path === store.state.route.path) return true
        if (path.test && path.test(store.state.route.path)) return true
        return false
      })) {
        router.push('/login')
      }
    }
    
    // console.error('err utils/request : ' + error.response.data.message) // for debug
    return Promise.reject(error)
  })

export default service
//#ALEXMODI
